<template>
  <div class="new-link-wrap">
    <el-dialog title="小程序页面" append-to-body :visible.sync="myVisible" :modal-append-to-body="false"
      class="add-label-dialog" :close-on-click-modal="false" @close="close">
      <el-tabs v-model="activeName" @tab-click="handleClick" style="height: 60vh;">
        <el-tab-pane label="常用页面" name="first">
          <el-table v-loading="loading1" size="small" :data="tableData1" fit highlight-current-row align="center"
            :header-cell-style="{ background: '#F9F9F9' }" height="100%" @selection-change="handleSelectionChange1"
            ref="tableData1Ref" style="font-size: 13px">
            <el-table-column type="selection" min-width="55"></el-table-column>
            <el-table-column type="index" min-width="75" label="序号"></el-table-column>
            <el-table-column prop="name" label="页面名称" show-overflow-tooltip min-width="120"></el-table-column>
            <el-table-column prop="minUrl" label="链接/路径" show-overflow-tooltip min-width="220"></el-table-column>

          </el-table>
          <div class="staff-pagination">
            <div class="staff-l">
              已选：{{ selectedData ? selectedData.name || '' : '' }}
            </div>
            <el-pagination @current-change="changePage" @size-change="changeSize" :current-page="formInline.page"
              :page-size="formInline.size" layout="total, sizes, prev, pager, next, jumper" :total="total1"
              :page-sizes="[20, 50, 100, 200, 500]">
            </el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="自定义页面" name="second">
          <el-table v-loading="loading2" size="small" :data="tableData2" fit highlight-current-row align="center"
            :header-cell-style="{ background: '#F9F9F9' }" height="100%" @selection-change="handleSelectionChange2"
            ref="tableData2Ref" style="font-size: 13px">
            <el-table-column type="selection" min-width="55"></el-table-column>
            <el-table-column type="index" min-width="75" label="序号"></el-table-column>
            <el-table-column prop="name" label="页面名称" show-overflow-tooltip min-width="120"></el-table-column>
            <el-table-column prop="minUrl" label="链接/路径" show-overflow-tooltip min-width="220"></el-table-column>
          </el-table>
          <div class="staff-pagination">
            <div class="staff-l">
              已选：{{ selectedData ? selectedData.name || '' : '' }}
            </div>
            <el-pagination @current-change="changePage2" @size-change="changeSize2" :current-page="formInline2.page"
              :page-size="formInline2.size" layout="total, sizes, prev, pager, next, jumper" :total="total2"
              :page-sizes="[20, 50, 100, 200, 500]">
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer">
        <el-button size="small " @click="myVisible = false" style="margin-right:20px">取 消</el-button>
        <el-button type="primary" size="small" :disabled="!selectedData" @click="confirmWeicome()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  customizePageApi,
  commonPageApi,
} from "@/api/groupSop.js";
export default {
  name: "newLink",
  components: {
  },
  props: {

  },
  data() {
    return {
      activeName: 'first',
      formInline: {
        page: 1,
        size: 20,
      },
      total1: 0,
      loading1: false,
      /**常用页面表格数据 */
      tableData1: [],


      /**自定义页面表格数据 */
      tableData2: [],
      formInline2: {
        page: 1,
        size: 20,
      },
      total2: 0,
      loading2: false,

      selectedData: null,

      myVisible: false,
    };
  },
  created() {
    this.getCommonData()
  },
  methods: {

    show(form) {
      // 目前只有一个选项  不支持回显  因为有多个tab
      // this.selectedData = form && form.length ? form[0] : null
      this.myVisible = true
    },
    handleClick(tab, event) {
      console.log('handleClick----', tab, event);
      if (tab.name == 'second' && !(this.tableData2 && this.tableData2.length)) {
        this.getCumData()
      }
    },

    /**页码改变 */
    changePage(val) {
      this.formInline.page = val
      this.getCommonData()
    },
    /**页大小改变 */
    changeSize(val) {
      this.formInline.page = 1
      this.formInline.size = val
      this.getCommonData()
    },
    /**获取数据 常用页面 */
    getCommonData() {
      console.log(1111, this.formInline);

      this.loading1 = true
      commonPageApi(this.formInline, localStorage.getItem("Authorization"))
        .then((res) => {
          this.loading1 = false
          if (res.error.code == 200) {
            this.total1 = Number(res.data.total || 0);
            this.tableData1 = res.data.records;
          }
        })
        .catch((err) => {
          this.loading1 = false
        });
    },
    /**选中 常用 */
    handleSelectionChange1(val) {
      let arrays;
      if (val.length >= 2) {
        arrays = val.splice(0, val.length - 1);
        arrays.forEach((row) => {
          this.$refs.tableData1Ref.toggleRowSelection(row);
        })
      }
      this.selectedData = {...val[0],pageType:0}
      console.log('selectedData-------', val);

    },


    /**页码改变 */
    changePage2(val) {
      this.formInline2.page = val
      this.getCumData()
    },
    /**页大小改变 */
    changeSize2(val) {
      this.formInline2.page = 1
      this.formInline2.size = val
      this.getCumData()
    },
    /**获取数据 自定义 */
    getCumData() {
      this.loading2 = true
      customizePageApi(this.formInline2, localStorage.getItem("Authorization"))
        .then((res) => {
          this.loading2 = false
          if (res.error.code == 200) {
            this.total2 = Number(res.data.total || 0);
            res.data.records.forEach(v => {
              v.minUrl = v.id
                ? `/pages/custom-page/index?fitId=${v.id}`
                : "";
            })
            this.tableData2 = res.data.records;
          }
        })
        .catch((err) => {
          this.loading2 = false
        });
    },

    /**选中 自定义 */
    handleSelectionChange2(val) {
      let arrays;
      if (val.length >= 2) {
        arrays = val.splice(0, val.length - 1);
        arrays.forEach((row) => {
          this.$refs.tableData2Ref.toggleRowSelection(row);
        })
      }
      this.selectedData =  {...val[0],pageType:1}
    },

    // 确定
    confirmWeicome() {
      console.log('确定----', this.selectedData);
      if (!this.selectedData) {
        return this.$message.warning('请选择页面后再操作');
      }
      this.$emit('comfirm', this.selectedData)
      this.myVisible = false
    },
    //关闭
    close() {
      console.log('关闭----', this.selectedData);
      this.$emit('close',)
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/.el-dialog__body {
  padding: 0 20px !important;
}

/deep/.el-tabs__content {
  height: calc(60vh - 60px);
}

/deep/.el-tab-pane {
  height: 100%;
}

/deep/.el-table {
  height: calc(100% - 40px) !important;
}

.staff-pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  height: 40px;

  .staff-l {
    min-width: 160px;
    font-size: 14px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;

  }
}

/deep/.el-table__header-wrapper .el-checkbox {
  display: none;
}
</style>